import React from "react";
import useStore from "../../../../context/useStore";
import useRole from "../../../../hooks/useRole/useRole";
import useLeads from "../useLeads";
import useLeadFilters from "./useLeadFilters";
import { LEAD_PRESETS } from "./leadPresets";

const searchPlaceholderByCategory = {
  PRO: "Société, siren/siret ou email…",
  DOMI: "Nom, prénom ou email…",
};

const QuickFilterBar = ({
  showAdvanced,
  onToggleAdvanced,
  activeFilterCount,
}) => {
  const [state] = useStore();
  const { myRole } = useRole();
  const { productCategory } = useLeads();
  const { LEAD_STATUS } = state.constants.items;
  const userId = state.auth?.user?.id;
  const { leadsFilters, actions } = useLeadFilters();
  const { terms, statuses } = leadsFilters.filters;

  const presetCtx = { userId, myRole, LEAD_STATUS };
  const activePresetId = actions.getActivePresetId(presetCtx);
  const availablePresets = LEAD_PRESETS.filter((p) => p.isAvailable(presetCtx));

  // Statut "rapide" : 3 raccourcis de statut dans le toolbar. Un clic = ce
  // seul statut actif (toggle off si déjà seul actif), recherche immédiate.
  const quickStatuses = [
    { id: "TO_DO", label: "À traiter", icon: "fa-bullseye" },
    { id: "IN_PROGRESS", label: "En cours", icon: "fa-angle-double-right" },
    { id: "DONE", label: "Convertis", icon: "fa-check" },
  ].filter((qs) => LEAD_STATUS.some((s) => s.id === qs.id));

  const isQuickStatusOn = (id) =>
    statuses.length === 1 && statuses[0] === id;

  const onQuickStatus = (id) => {
    actions.applyAndSearch({ statuses: isQuickStatusOn(id) ? [] : [id] });
  };

  return (
    <>
      <div className="lf-toolbar">
        {quickStatuses.length > 0 && (
          <div className="lf-seg" role="group" aria-label="Statut rapide">
            {quickStatuses.map((qs) => (
              <button
                key={qs.id}
                type="button"
                className={isQuickStatusOn(qs.id) ? "lf-on" : ""}
                aria-pressed={isQuickStatusOn(qs.id)}
                onClick={() => onQuickStatus(qs.id)}
              >
                <i className={`fa ${qs.icon}`} />
                {qs.label}
              </button>
            ))}
          </div>
        )}

        <div className="lf-search">
          <i className="fa fa-search" />
          <input
            type="text"
            value={terms}
            placeholder={searchPlaceholderByCategory[productCategory]}
            onChange={(e) =>
              actions.updateFilters({
                target: { name: "terms", value: e.target.value },
              })
            }
          />
        </div>

        <button
          type="button"
          className={
            "lf-btn lf-btn-ghost" + (activeFilterCount > 0 ? " lf-badge-on" : "")
          }
          onClick={onToggleAdvanced}
          aria-expanded={showAdvanced}
        >
          <i className="fa fa-sliders" />
          Filtres
          {activeFilterCount > 0 && (
            <span className="lf-count">{activeFilterCount}</span>
          )}
        </button>

        <button type="submit" className="lf-btn lf-btn-primary">
          <i className="fa fa-search" />
          Rechercher
        </button>
      </div>

      {availablePresets.length > 0 && (
        <div className="lf-presets">
          <span className="lf-lbl">Vues rapides</span>
          {availablePresets.map((preset) => {
            const on = preset.id === activePresetId;
            return (
              <button
                key={preset.id}
                type="button"
                className={"lf-chip" + (on ? " lf-on" : "")}
                aria-pressed={on}
                onClick={() => actions.applyPreset(preset, presetCtx)}
              >
                <i className={`fa ${preset.icon}`} />
                {preset.label}
              </button>
            );
          })}
        </div>
      )}
    </>
  );
};

export default QuickFilterBar;
